export default __webpack_public_path__ + "static/media/v9.2c382c86.svg";